import { PlanType } from '@showbie-socrative/socrative-utils';
import { minTime, subDays } from 'date-fns';

import { useAccount } from '~teacher/hook/account';

export const reportDaysBack: Map<PlanType, number> = new Map([
  [PlanType.Free, 30],
  [PlanType.FreeLegacy, 30],
  [PlanType.Essentials, 90],
  [PlanType.Starter, 90],
  [PlanType.Complete, Infinity],
  [PlanType.Organization, Infinity],
  [PlanType.Pro, Infinity], // Unlimited
]);

export function useReportsCutOffDate() {
  return useAccount({
    select: ({ plan }) => {
      const daysBack = reportDaysBack.get(plan) ?? 30;

      if (daysBack === Infinity) {
        return { days: Infinity, cutOff: new Date(minTime) };
      }

      const cutOff = subDays(new Date(), daysBack);

      return {
        days: daysBack,
        cutOff: cutOff,
      };
    },
  });
}
